// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__qd9pi","layoutContent":"Layout_layoutContent__XbmS5"};